import React, { createContext, useState, useEffect } from 'react';
import { particleOptions } from './particleOptions.js';
import { themes } from './themes'

// Create the ThemeContext
export const ThemeContext = createContext();

const readSetting = (key, options, fallback) => {
    try {
        const value = window.localStorage.getItem(key);
        return Object.prototype.hasOwnProperty.call(options, value) ? value : fallback;
    } catch {
        return fallback;
    }
};

export const ThemeProvider = ({ children }) => {
    // Ignore stale or unavailable browser storage values to keep theme lookups valid.
    const [theme, setTheme] = useState(() => {
        return readSetting('theme', themes, 'universe');
    });
    const [particleOption, setParticleOption] = useState(() => {
        return readSetting('particleOption', particleOptions, 'universe');
    });

    useEffect(() => {
        try {
            window.localStorage.setItem('theme', theme);
            window.localStorage.setItem('particleOption', particleOption);
        } catch {
            // The app still works when the browser blocks persistent storage.
        }
    }, [theme, particleOption]);

    // Function to change the theme
    const changeTheme = (newTheme, newParticle) => {
        if (newTheme != null && Object.prototype.hasOwnProperty.call(themes, newTheme)) {
            setTheme(newTheme);
        }
        if (newParticle != null && Object.prototype.hasOwnProperty.call(particleOptions, newParticle)) {
            setParticleOption(newParticle);
        }
    };

    return (
        <ThemeContext.Provider value={{ theme, particleOption, changeTheme, themes, particleOptions }}>
            {children}
        </ThemeContext.Provider>
    );
};
